export enum StatementContentType {
  EMBEDDED = 'EMBEDDED',
  FILE = 'FILE',
}
